var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53942 4.25015C1.97216 3.61616 1.68854 3.29917 1.67784 3.02976C1.66854 2.79573 1.76912 2.57079 1.94972 2.42167C2.15763 2.25 2.58299 2.25 3.43371 2.25H14.5659C15.4166 2.25 15.842 2.25 16.0499 2.42167C16.2305 2.57079 16.3311 2.79573 16.3218 3.02976C16.3111 3.29917 16.0275 3.61616 15.4602 4.25015L11.1805 9.03332C11.0674 9.1597 11.0109 9.22289 10.9706 9.29481C10.9348 9.35859 10.9086 9.42726 10.8927 9.49863C10.8748 9.57911 10.8748 9.6639 10.8748 9.83348V13.8438C10.8748 13.9905 10.8748 14.0638 10.8512 14.1272C10.8303 14.1832 10.7963 14.2334 10.752 14.2736C10.7019 14.3192 10.6338 14.3464 10.4976 14.4009L7.94764 15.4209C7.67199 15.5311 7.53416 15.5863 7.42351 15.5633C7.32676 15.5432 7.24185 15.4857 7.18725 15.4033C7.12481 15.3091 7.12481 15.1607 7.12481 14.8638V9.83348C7.12481 9.6639 7.12481 9.57911 7.1069 9.49863C7.09102 9.42726 7.06478 9.35859 7.02903 9.29481C6.98871 9.22289 6.93217 9.1597 6.8191 9.03332L2.53942 4.25015Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.3e4cb649af50c5198831ac3e6e23b2ab.svg";
export { ForwardRef as ReactComponent };